import * as React from 'react';

import { apiResource, useAPIStream } from '../../state';

export type AISearchRecommendedQuestionTarget = { organization: string };

export interface AISearchRecommendedQuestionItem {
    type: 'recommended-question';
    question: string;
}

/**
 * Suggest questions for the user to ask when no query has been provided.
 */
export function useAISearchRecommendedQuestions(
    target: AISearchRecommendedQuestionTarget | null
): AISearchRecommendedQuestionItem[] {
    const [stream] = useAPIStream(
        target === null || process.env.GITBOOK_PREDICTABLE_UI
            ? null
            : apiResource('streamRecommendedQuestionsInOrganization', {
                  organizationId: target.organization,
              })
    );

    return React.useMemo(() => {
        return stream.map((question) => ({
            type: 'recommended-question',
            question: question.question,
        }));
    }, [stream]);
}
